import React, { useEffect, useRef, useState } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import Select from "react-select";
import { FaUpload, FaTimes } from "react-icons/fa";
import axiosInstance from "../Axios/AxiosInstance";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import AsyncSelect from "react-select/async";

const CreateScheme = () => {

  const [schemeName, setSchemeName] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dealerstatusType, setDealerStatusType] = useState("Manual")
  const [materialstatusType, setMaterialStatusType] = useState("Manual")
  const [selectedCategory, setSelectedCategory] = useState("dealer");
  const [imagePreview, setImagePreview] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [dealerSelect, setDealerSelect] = useState([]);
  const [dealerSelectFile, setDealerSelectFile] = useState(null);
  const [stateSelect, setstateSelect] = useState([]);
  const [materialSelect, setMaterialSelect] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [scanSequence, setScanSequence] = useState("");
  const [selectedOption, setSelectedOption] = useState('Single');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false)

  const [selectedFileName, setSelectedFileName] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [materialOption, setMaterialOption] = useState([]);
  const [selectedFileNameMaterial, setSelectedFileNameMaterial] = useState('');
  const [materialSelectFile, setMaterialSelectFile] = useState(null);

    const [existingDataPopup, setExistingDataPopup] = useState(false);
  const [existingData, setExistingData] = useState([]);
  const [formDataBackup, setFormDataBackup] = useState(null);

  const today = new Date().toISOString().split('T')[0];

  const fileInputRef = useRef(null);
  const fileInputRefImage = useRef(null);
  const fileInputRefMaterial = useRef(null);

  const navigate = useNavigate();

  const userinfo = JSON.parse(sessionStorage.getItem('userinfo')) || {};
  const employeeId = userinfo.employeeId || 'N/A';

  useEffect(() => {
    getAllState()
    getAllMaterial()
  }, [])

  const loadDealerOptions = async (inputValue, callback) => {
    if (!inputValue.trim() || inputValue.length < 5) {
      callback([]);
      return;
    }

    try {
      const response = await axiosInstance.get("/schemes/GetAllDealer", {
        params: { searchItem: inputValue },
      });

      const options = response.data.map((dealer) => ({
        label: `${dealer.dealerCode} - ${dealer.dealerName}`,
        value: dealer.dealerCode,
      }));

      callback(options);
    } catch (error) {
      console.error("Error fetching dealer options:", error);
      callback([]);
    }
  };

  const getAllState = () => {
    axiosInstance.get('schemes/GetAllStates')
      .then(response => {
        const transformed = response.data.map((state) => ({
          value: state.id,
          label: state.stateName,
        }));
        setStateOptions(transformed);
      })
      .catch(error => {
        console.error('Error fetching states:', error);
      });
  };

  const getAllMaterial = () => {
    axiosInstance.get('schemes/GetMaterialCodes')
      .then(response => {
        const transformed = response.data.map((material) => ({
          value: material.materialCode,
          label: `${material.materialCode} - ${material.materialDescription}`,
        }));
        setMaterialOption(transformed);
      })
      .catch(error => {
        console.error('Error fetching states:', error);
      });
  };

  const handleSequenceOptions = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleStateChange = (selectedOptions) => {
    setstateSelect(selectedOptions)
  }

  const handleMaterialChange = (selectedOptions) => {
    setMaterialSelect(selectedOptions)
    setMaterialStatusType("Manual")
  }

  const handledealerChange = (selectedOptions) => {
    setDealerSelect(selectedOptions)
    setDealerStatusType("Manual")
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = file.type;
    if (fileType === "image/jpeg" || fileType === "image/png") {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
      setSelectedFile(file)
      setPdfFile(null);
    } else if (fileType === "application/pdf") {
      setPdfFile(file);
      setSelectedFile(file)
      setImagePreview(null);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      setImagePreview(URL.createObjectURL(file));
    } else {
      setImagePreview(null);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileChangeDealer = (event) => {

    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv"
    ];

    const file = event.target.files[0];

    if (file) {
      if (allowedTypes.includes(file.type)) {
        setSelectedFileName(file.name);
        setDealerSelectFile(file);
        setDealerStatusType("Upload");
      } else {
        alert("Invalid file type. Please upload an Excel or CSV file.");
        event.target.value = "";
      }
    }
  };

  const handleClearFile = () => {
    setSelectedFileName('');
    setDealerSelectFile(null);
    setDealerStatusType("")
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleIconClickMaterial = () => {
    if (fileInputRefMaterial.current) {
      fileInputRefMaterial.current.click();
    }
  };
  
  const handleFileChangeMaterial = (event) => {
    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv"
    ];
  
    const file = event.target.files[0];
  
    if (file) {
      if (allowedTypes.includes(file.type)) {
        setSelectedFileNameMaterial(file.name);
        setMaterialSelectFile(file); 
        setMaterialStatusType("Upload");
      } else {
        alert("Invalid file type. Please upload an Excel or CSV file.");
        event.target.value = "";
      }
    }
  };
  
  const handleClearFileMaterial = () => {
    setSelectedFileNameMaterial('');
    setMaterialSelectFile(null)
    setMaterialStatusType("")
    if (fileInputRefMaterial.current) {
      fileInputRefMaterial.current.value = null;
    }
  };

  const customStyles = {
    valueContainer: (base) => ({
      ...base,
      maxHeight: "80px",
      overflowY: "auto",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "250px",
      overflowY: "auto",
    }),
  };

  const validateForm = () => {
    const newErrors = {};

    if (!schemeName.trim()) newErrors.schemeName = "Scheme Name is required.";
    if (!description.trim()) newErrors.description = "Description is required.";
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      newErrors.amount = "Amount is required.";
    }
    if (!startDate) newErrors.startDate = "Start Date is required.";
    if (!endDate) newErrors.endDate = "End Date is required.";

    if (selectedCategory === "dealer") {
      if (!selectedFileName && (!dealerSelect || dealerSelect.length === 0)) {
        newErrors.dealerSelect = "Select dealers or upload a file.";
      }
    }
    if (selectedCategory === "state" && (!stateSelect || stateSelect.length === 0)) {
      newErrors.stateSelect = "State data is required";
    }

    if ((startTime && !endTime) || (!startTime && endTime)) {
      if (!startTime) newErrors.startTime = "Start Time is required.";
      if (!endTime) newErrors.endTime = "End Time is required.";
    } else if (startTime && endTime) {
      const [startHour, startMinute] = startTime.split(":").map(Number);
      const [endHour, endMinute] = endTime.split(":").map(Number);
      const start = new Date();
      start.setHours(startHour, startMinute, 0);
      const end = new Date();
      end.setHours(endHour, endMinute, 0);

      if (start >= end) {
        toast.error("Please ensure the End Time is later than the Start Time.");
        return false;
      }

      if (!selectedFileNameMaterial && (!materialSelect || materialSelect.length === 0)) {
        newErrors.materialSelect = "Material selection is required when Time Specific is set.";
      }
      
    }

    if (new Date(startDate) > new Date(endDate)) {
      toast.error("Start Date must be before End Date.");
      return false;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleSubmit = async (e) => {
    setButtonLoading(true);
    setIsLoading(true);

    e.preventDefault();

    if (validateForm()) {
      const startDateObj = new Date(startDate);
      const endDateObj = new Date(endDate);

      const formData = new FormData();
      formData.append('schemeName', schemeName);
      formData.append('description', description);
      formData.append('flyer', selectedFile);
      formData.append('amount', amount);
      formData.append('startDate', startDateObj.toISOString());
      formData.append('endDate', endDateObj.toISOString());
      formData.append('isActive', true);

      dealerSelect.forEach((dealer, index) => {
        formData.append(`dealerCode[${index}]`, dealer.value);
      });

      stateSelect.forEach((state, index) => {
        formData.append(`stateId[${index}]`, state.value);
      });

      materialSelect.forEach((state, index) => {
        formData.append(`materialCode[${index}]`, state.value);
      });

      formData.append('dealerCodeFile', dealerSelectFile);
      formData.append('materialCodeFile', materialSelectFile);
      formData.append('inTime', startTime);
      formData.append('outTime', endTime);
      formData.append('scanSequence', scanSequence);
      formData.append('scanSequenceType', selectedOption);
      formData.append('dealerFileStatus', dealerstatusType);
      formData.append('materialFileStatus', materialstatusType);
      formData.append('createdAt', new Date().toISOString());
      formData.append('createdBy', employeeId);

      try {
        const checkResponse = await axiosInstance.post(
          '/schemes/CheckExistingSchemeData',
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "*/*"
            }
          }
        );

        const { count, existingData } = checkResponse.data;

        if (count === 0) {
          await addScheme(formData);

        } else {
          setFormDataBackup(formData);
          setExistingData(existingData);
          setExistingDataPopup(true);
        }

      } catch (error) {
        if (error.response) {
          toast.error(error.response.data.value || "Something went wrong.");
        } else if (error.request) {
          console.error('Error Request:', error.request);
          toast.error("Request error. Please try again.");
        } else {
          console.error('Error Message:', error.message);
          toast.error("Unexpected error. Please try again.");
        }
      }
      setIsLoading(false);

      setButtonLoading(false);
    } else {
      console.log("Form has errors.");
      setIsLoading(false);
      setButtonLoading(false);
    }
  };

  const addScheme = async (formData) => {
    try {
      const addResponse = await axiosInstance.post('/schemes/AddSchemes', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*"
        }
      });

      toast.success(addResponse.data, {
        onClose: () => navigate('/Scheme'),
        autoClose: 2000
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.value) {
        toast.error(error.response.data.value);
      } else {
        toast.error("Add Scheme failed.");
      }
    }
  };





  return (
    <div className="flex flex-col min-h-screen">
      <Header title="Create Scheme" />
      <div className="flex flex-1 px-8 py-4 gap-6">
        <div className="w-2/3 bg-white rounded-lg p-6 shadow-md">
          <div className="mb-4">
            <label className="block font-semibold text-[#1e365e]">New Scheme</label>
            <input className="border-b w-full outline-none mt-3"
              type="text"
              placeholder="Scheme Name"
              value={schemeName}
              onChange={(e) => setSchemeName(e.target.value)}
            />
            <div className="min-h-[24px] mt-1">
              {errors.schemeName && (
                <span className="text-red-500 text-sm">{errors.schemeName}</span>
              )}
            </div>
          </div>

          <div className="mb-2">
            <textarea
              className="p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:border-blue-400 transition duration-200"
              rows="4"
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
            <div className="min-h-[24px]">
              {errors.description && (
                <span className="text-red-500 text-sm">{errors.description}</span>
              )}
            </div>
          </div>

          <div className="flex gap-4 mb-4">
            <div className="flex-1">
              <input className="w-full border p-2 rounded-md focus:outline-none" placeholder="₹ Amount" value={amount}
                onChange={(e) => setAmount(e.target.value)} />
              <div className="min-h-[24px] mt-1">
                {errors.amount && (
                  <span className="text-red-500 text-sm">{errors.amount}</span>
                )}
              </div>
            </div>

            <div className="flex-1">
              <input className="w-full border p-2 rounded-md focus:outline-none"
                type="text"
                value={startDate}
                placeholder="Start Date"
                onChange={(e) => setStartDate(e.target.value)}
                min={today}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!e.target.value) e.target.type = "text";
                }} />
              <div className="min-h-[24px] mt-1">
                {errors.startDate && (
                  <span className="text-red-500 text-sm">{errors.startDate}</span>
                )}
              </div>
            </div>

            <div className="flex-1">
              <input className="w-full border p-2 rounded-md focus:outline-none" placeholder="End Date" type="text"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                min={today}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!e.target.value) e.target.type = "text";
                }} />
              <div className="min-h-[24px] mt-1">
                {errors.endDate && (
                  <span className="text-red-500 text-sm">{errors.endDate}</span>
                )}
              </div>

            </div>
          </div>

          <div
            className="mb-4 border-dashed border-2 border-gray-400 rounded-lg h-32 flex justify-center items-center text-gray-500 text-sm cursor-pointer"
            onClick={() => fileInputRefImage.current.click()}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            Drag and drop or click here to upload PNG
            <input
              type="file"
              accept=".jpg, .jpeg, .png, .pdf"
              onChange={handleFileChange}
              ref={fileInputRefImage}
              style={{ display: 'none' }}
            />
          </div>
          {imagePreview && (
            <div className="relative w-16 h-16">
              <img
                src={imagePreview}
                alt="Preview"
                className="w-full h-full object-cover rounded-md"
              />
              <button
                onClick={() => setImagePreview(null)}
                className="absolute top-0 right-0 bg-white rounded-full p-1 text-red-500 hover:text-red-700"
                aria-label="Remove image"
              >
                <FaTimes size={12} />
              </button>
            </div>
          )}

          {pdfFile && (
            <div className="relative flex items-center">
              <span className="text-sm text-gray-700">{pdfFile.name}</span>
              <button
                onClick={() => setPdfFile(null)}
                className="ml-2 text-red-500 hover:text-red-700"
                aria-label="Remove PDF"
              >
                <FaTimes size={12} />
              </button>
            </div>
          )}
        </div>

        <div className="w-1/3 bg-white rounded-lg p-6 shadow-md">
          <div className="mb-2">
            <label className="block font-semibold text-[#1e365e] mb-2">Category</label>
            <div className="flex gap-2">
              <button
                className={`px-4 py-1 rounded-full ${selectedCategory === "dealer" ? "bg-[#4453a4] text-white" : "bg-gray-200"
                  }`}
                onClick={() => {
                  setSelectedCategory("dealer");
                  setstateSelect([]);
                }}
              >
                Dealer
              </button>
              <button
                className={`px-4 py-1 rounded-full ${selectedCategory === "state" ? "bg-[#4453a4] text-white" : "bg-gray-200"
                  }`}
                onClick={() => {
                  setSelectedCategory("state");
                  setDealerSelect([]);
                }}
              >
                State
              </button>
            </div>
          </div>


          {selectedCategory === "dealer" && (
            <div className="min-h-[100px]">
              <label className="mb-2 font-semibold text-[#1e365e]">Dealer</label>
              <div className="relative">
                <AsyncSelect
                  isMulti
                  cacheOptions
                  defaultOptions
                  loadOptions={loadDealerOptions}
                  value={dealerSelect}
                  onChange={handledealerChange}
                  className="w-full"
                  placeholder="Search and select dealers"
                  styles={customStyles}
                  isDisabled={!!selectedFileName}
                  closeMenuOnSelect={false}
                />

                <input
                  type="file"
                  accept=".xls,.csv"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChangeDealer}
                  disabled={dealerSelect.length > 0}
                />

                <FaUpload
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white bg-[#1e365e] p-1 rounded cursor-pointer"
                  size={24}
                  onClick={handleIconClick}
                />
              </div>

              {selectedFileName && (
                <div className="mt-2 text-sm text-gray-600 flex items-center">
                  <span>Selected file: {selectedFileName}</span>
                  <FaTimes
                    className="ml-2 text-red-500 cursor-pointer"
                    onClick={handleClearFile}
                  />
                </div>
              )}

              {errors.dealerSelect && (
                <span className="text-red-500 text-sm">{errors.dealerSelect}</span>
              )}
            </div>
          )}

          {selectedCategory === "state" && (
            <div className="min-h-[100px]">
              <label className="mb-2 font-semibold text-[#1e365e]">State</label>
              <div className="relative">
                <Select
                  isMulti
                  options={stateOptions}
                  value={stateSelect}
                  onChange={handleStateChange}
                  className="w-full"
                  placeholder="Select states"
                  styles={customStyles}
                />
              </div>
              {errors.stateSelect && (
                <span className="text-red-500 text-sm">{errors.stateSelect}</span>
              )}
            </div>
          )}

          <div className="mb-3">
            <label className="block font-semibold text-[#1e365e] mb-2">Conditions</label>
          </div>

          <div className="mb-2">
            <label className="block font-semibold text-[#1e365e] mb-2">Time Specific</label>
            <div className="flex gap-2">
              <div className="w-1/2">
                <input
                  type="text"
                  placeholder="Start Time"
                  value={startTime}
                  onFocus={(e) => (e.target.type = "time")}
                  onBlur={(e) => {
                    if (!e.target.value) e.target.type = "text";
                  }}
                  onChange={(e) => setStartTime(e.target.value)}
                  className={`p-2 border ${errors.startTime ? 'border-red-500' : 'border-gray-300'
                    } rounded-md w-full focus:outline-none focus:border-blue-400 transition duration-200`}
                />
                <div className="min-h-[24px] mt-1">
                  {errors.startTime && (
                    <span className="text-red-500 text-sm">{errors.startTime}</span>
                  )}
                </div>
              </div>
              <div className="w-1/2">
                <input
                  type="text"
                  value={endTime}
                  placeholder="End Time"
                  onFocus={(e) => (e.target.type = "time")}
                  onBlur={(e) => {
                    if (!e.target.value) e.target.type = "text";
                  }}
                  onChange={(e) => setEndTime(e.target.value)}
                  className={`p-2 border ${errors.endTime ? 'border-red-500' : 'border-gray-300'
                    } rounded-md w-full focus:outline-none focus:border-blue-400 transition duration-200`}
                />
                <div className="min-h-[24px] mt-1">
                  {errors.endTime && (
                    <span className="text-red-500 text-sm">{errors.endTime}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="min-h-[100px]">
            <label className="mb-2 font-semibold text-[#1e365e]">Materials</label>
            <div className="relative">
              <Select
                isMulti
                options={materialOption}
                value={materialSelect}
                onChange={handleMaterialChange}
                className="w-full"
                placeholder="Select Materials"
                styles={customStyles}
                isDisabled={!!selectedFileNameMaterial || !startTime || !endTime}
                closeMenuOnSelect={false}
              />

              <input
                type="file"
                accept=".xls,.csv"
                ref={fileInputRefMaterial}
                style={{ display: "none" }}
                onChange={handleFileChangeMaterial}
                disabled={materialSelect.length > 0 || !startTime || !endTime}
              />

              <FaUpload
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white bg-[#1e365e] p-1 rounded cursor-pointer"
                size={24}
                onClick={handleIconClickMaterial}
              />
            </div>

            {selectedFileNameMaterial && (
              <div className="mt-2 text-sm text-gray-600 flex items-center">
                <span>Selected file: {selectedFileNameMaterial}</span>
                <FaTimes
                  className="ml-2 text-red-500 cursor-pointer"
                  onClick={handleClearFileMaterial}
                />
              </div>
            )}

            {errors.materialSelect && (
              <span className="text-red-500 text-sm">{errors.materialSelect}</span>
            )}
          </div>


          <div className="mb-4">
            <label className="block font-semibold text-[#1e365e] mb-2">Scan Sequence</label>
            <input
              type="number"
              className="p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:border-blue-400 transition duration-200"
              placeholder="Enter Sequence"
              value={scanSequence}
              onChange={(e) => setScanSequence(e.target.value)}
            />
            <div className="flex gap-4 mt-3">
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  name="scan"
                  id="Single"
                  value="Single"
                  checked={selectedOption === 'Single'}
                  onChange={handleSequenceOptions}
                />
                <label htmlFor="Single">Single</label>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  name="scan"
                  id="Every"
                  value="Every"
                  checked={selectedOption === 'Every'}
                  onChange={handleSequenceOptions}
                />
                <label htmlFor="Every">Every</label>
              </div>
            </div>
            {errors.scanSequence && (
              <span className="text-red-500 text-sm">{errors.scanSequence}</span>
            )}
          </div>

          <div className="flex justify-end gap-4 mt-8">
            <button
              className="px-4 py-1 border border-gray-400 rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 font-medium"
              onClick={() => navigate("/Scheme")}
            >
              Cancel
            </button>
            <button
              className="w-28 px-4 py-1 bg-[#1e365e] text-white rounded-md hover:bg-[#2c4e94] font-semibold flex items-center justify-center gap-2 disabled:opacity-50"
              onClick={handleSubmit}
              disabled={buttonLoading}
            >
              {buttonLoading ? (
                <>
                  <span>Saving</span>
                  <span className="loader"></span>
                </>
              ) : (
                'Save'
              )}
            </button>
          </div>

        </div>
        {existingDataPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-4 w-88 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-3 ">Existing Data Found</h3>

              <ul className="list-disc pl-5 mb-4 max-h-40 overflow-y-auto text-sm text-gray-700">
                {existingData.slice(0, 10).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
                {existingData.length > 10 && (
                  <li>+{existingData.length - 10} more</li>
                )}
              </ul>
              <p className="text-center text-lg text-gray-800 font-medium mt-2 mb-4">
                Do you want to proceed to Create scheme?
              </p>
              <div className="flex justify-center gap-14">
                <button
                  className="bg-[#1e365e] text-white px-4 py-2 rounded"
                  onClick={() => {
                    addScheme(formDataBackup);
                    setExistingDataPopup(false);
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-gray-500 text-white px-4 py-2 rounded"
                  onClick={() => {
                    setExistingDataPopup(false);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
        {isLoading && (
          <div className="fixed inset-0 flex items-center justify-center backdrop-blur-[1px] bg-black/10 z-50">
            <FaSpinner className="animate-spin text-[#1e365e] text-4xl" />
          </div>
        )}
      </div>
      <Footer />
      <ToastContainer />
    </div>

  );
};

export default CreateScheme;
